import appMdl from "./app";
import apiMdl from "./api";
import filterMdl from "./filter";

export default [...appMdl, ...apiMdl, ...filterMdl];
